module.exports = __webpack_public_path__ + "img/演唱-意外.a00c150d.jpg";